import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import LoginScreen from '../pages/Login/Login'
import PrivateRoute from './PrivateRouter'
import Validation from '../pages/Login/Validation'
import CompleteRegister from '../pages/Login/CompleteRegister'
import SuccessMsg from '../pages/Login/SuccessMsg'
import AdminRegister from '../pages/Login/AdminRegister'
import ClientPanel from '../pages/ClientPanel'
import HomeScreen from '../pages/ClientPanel/Home'
import CertificatesContent from '../pages/ClientPanel/Certificates'
import StockContent from '../pages/ClientPanel/Stock'
import ProductionFlow from '../pages/ClientPanel/ProductionFlow'
import PeopleContent from '../pages/ClientPanel/Accesses'
import OrdersContent from '../pages/ClientPanel/Orders'
import ServicesTable from '../pages/ClientPanel/ProductionFlow/ServicesTable'
import PCPGrid from '../pages/ClientPanel/ProductionFlow/PCPGrid'
import StagesTable from '../pages/ClientPanel/ProductionFlow/StagesTable'
import CreateServiceModal from '../components/Services/CreateServiceModal'
import AddOpInPcp from '../components/ModalWithoutColumns'
import CertificatesTable from '../pages/ClientPanel/Certificates/CertificateTable'
import ParameterTable from '../pages/ClientPanel/Certificates/ParameterTable'
import StockTable from '../pages/ClientPanel/Stock/StockTable'
import MovementTable from '../pages/ClientPanel/Stock/MovementsTable'
import TableAccesses from '../pages/ClientPanel/Accesses/AccessesTable'
import TableProfile from '../pages/ClientPanel/Accesses/ProfilesTable'
import CompaniesContent from '../pages/ClientPanel/Companies'
import NotFoundPage from '../pages/SystemErrors/NotFound'
import AddCertificateContent from '../pages/ClientPanel/Certificates/AddCertificate'
import SteelOrders from '../pages/ClientPanel/SteelOrders'
import CreateOrder from '../pages/ClientPanel/SteelOrders/AddOrder'
import AddParameterContent from '../pages/ClientPanel/Certificates/AddParameter'

const ClientPanelLayout = () => (
  <PrivateRoute>
    <ClientPanel />
  </PrivateRoute>
)

const Router = () => {
  return (
    <BrowserRouter basename='/'>
      <Routes>
        {/** Rotas Públicas */}
        <Route path='/' element={<LoginScreen />} />
        <Route path='/accessvalidation' element={<Validation />} />
        <Route path='/pendingmessage' element={<SuccessMsg />} />
        <Route path='/completeRegister' element={<CompleteRegister />} />
        <Route path='/internalaccess/:token' element={<AdminRegister />} />

        {/** Rotas Privadas dentro do ClientPanel */}
        <Route path='*' element={<NotFoundPage />} />
        <Route path='/panel' element={<ClientPanelLayout />}>
          <Route path='*' element={<NotFoundPage />} />
          <Route index element={<HomeScreen />} />
          <Route path='certificates' element={<CertificatesContent />}>
            <Route index element={<CertificatesTable />}/>
            <Route path='create' element={<AddCertificateContent />} />
            <Route path='params' element={<ParameterTable />}/>
            <Route path='params/create' element={<AddParameterContent />}/>
          </Route>
          <Route path='stock' element={<StockContent />}>
            <Route index element={<StockTable />} />
            <Route path='movement' element={<MovementTable />} />
          </Route>
          <Route path='production' element={<ProductionFlow />}>
            <Route index element={<PCPGrid />} />
            <Route path='pcp/:stageId' element={<AddOpInPcp />} />
            <Route path='services' element={<ServicesTable />} />
            <Route path='services/create' element={<CreateServiceModal />} />
            <Route path='stages' element={<StagesTable />} />
            {/* <Route path='stages/create' element={} /> */}
          </Route>
          <Route path='people' element={<PeopleContent />}>
            <Route index element={<TableAccesses />} />
            <Route path='profiles' element={<TableProfile />} />
          </Route>
          <Route path='orders' element={<OrdersContent />} />
          <Route path='steel' element={<SteelOrders />} >
            <Route index />
            <Route path='create' element={<CreateOrder />} />
            <Route path='products' />
          </Route>
          <Route path='companies' element={<CompaniesContent />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
